/**
 * Format price regarding the locale that is send with it
 * @date 12-9-2023 - 08:34:54
 *
 * @param {number} price
 * @param {string} l
 * @returns {*}
 */
const formatPrice = (price: number, l: string) => {
  return new Intl.NumberFormat(l, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};

/**
 * Calculate pricing by quantity.
 * TODO: Fix the multiplying of the floating numbers since this will bring up side effects in rounding them
 * @date 12-9-2023 - 08:35:39
 *
 * @param {number} price
 * @param {boolean} isPaint
 * @returns {number}
 */
const calculatePriceByQuantity = (price: number, quantity: number | undefined | null = 1) => {
  if (!quantity) {
    return price;
  }
  return quantity * price;
};

/**
 * Calculate unit price from total price and quantity with proper floating-point rounding.
 * Uses toFixed(2) to avoid floating-point arithmetic issues (e.g., 73.96 / 2 = 36.980000000000004).
 * This matches the rounding logic used in payment processing.
 *
 * @param {number | undefined} totalPrice - The total price for all items
 * @param {number | undefined} quantity - The quantity of items
 * @returns {number | undefined} The unit price rounded to 2 decimal places, or undefined if totalPrice is undefined
 */
const getUnitPrice = (totalPrice: number | undefined, quantity: number | undefined): number | undefined => {
  if (totalPrice === undefined || !quantity) {
    return totalPrice;
  }
  return Number((totalPrice / quantity).toFixed(2));
};

export { formatPrice, calculatePriceByQuantity, getUnitPrice };
